import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { cidade_id: '', temporada_id: '', nome: '', descricao: '' };

export default function AdminCampeonatos() {
  const [campeonatos, setCampeonatos] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [temporadas, setTemporadas] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    carregar();
    api.get('/cidades/todas').then(setCidades).catch(() => {});
    api.get('/temporadas').then(setTemporadas).catch(() => {});
  }, []);

  function carregar() { api.get('/campeonatos').then(setCampeonatos).catch(() => {}); }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      if (editando) { await api.put(`/campeonatos/${editando.id}`, { ...form, ativo: editando.ativo }); }
      else { await api.post('/campeonatos', form); }
      setMsg('Salvo!'); setForm(empty); setEditando(null); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover?')) return;
    await api.delete(`/campeonatos/${id}`); carregar();
  }

  return (
    <div>
      <h2 className="admin-title">Campeonatos</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? 'Editar' : 'Novo Campeonato'}</h3>
        <div className="form-row">
          <div className="form-group">
            <label>Cidade</label>
            <select value={form.cidade_id} onChange={e => setForm({ ...form, cidade_id: e.target.value })} required>
              <option value="">Selecione</option>
              {cidades.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Temporada</label>
            <select value={form.temporada_id} onChange={e => setForm({ ...form, temporada_id: e.target.value })} required>
              <option value="">Selecione</option>
              {temporadas.map(t => <option key={t.id} value={t.id}>{t.nome} {t.ano}</option>)}
            </select>
          </div>
        </div>
        <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required /></div>
        <div className="form-group"><label>Descrição</label><textarea value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })} rows={2} /></div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm(empty); }}>Cancelar</button>}
        </div>
      </form>
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Nome</th><th>Cidade</th><th>Temporada</th><th>Ativo</th><th>Ações</th></tr></thead>
          <tbody>
            {campeonatos.map(c => (
              <tr key={c.id}>
                <td>{c.nome}</td><td>{c.cidade_nome}</td><td>{c.temporada_nome} {c.temporada_ano}</td>
                <td>{c.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(c); setForm({ cidade_id: c.cidade_id, temporada_id: c.temporada_id, nome: c.nome, descricao: c.descricao || '' }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(c.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
